const Divider = () => <div className="h-[1px] w-full bg-neutral-200 content-none" />;

export default Divider;
